import React, { ReactNode, createContext, useState } from 'react';

interface CompaignFilledContextProps {
	filledCampaign: boolean;
	setFilledCampaign: (e: any) => void;
	isEndedCampaign: boolean;
	setEndedCampaign: (e: any) => void;
}

export const CompaignFilledContext = createContext<CompaignFilledContextProps>({
	filledCampaign: false,
	setFilledCampaign: () => null,
	isEndedCampaign: false,
	setEndedCampaign: () => null,
});

type CompaignFilledProviderProps = {
	children: ReactNode;
};

export const CompaignFilledProvider = ({
	children,
}: CompaignFilledProviderProps): JSX.Element => {
	const [filledCampaign, setFilledCampaign] = useState(false);
	const [isEndedCampaign, setEndedCampaign] = useState(false);

	return (
		<>
			<CompaignFilledContext.Provider
				value={{
					filledCampaign,
					setFilledCampaign,
					setEndedCampaign,
					isEndedCampaign,
				}}
			>
				{children}
			</CompaignFilledContext.Provider>
		</>
	);
};
